import "../scss/app.scss";
import "whatwg-fetch";
import MobileMenuButton from "./components/MobileMenuButton";
import DownloadImageButton from "./components/DownloadImageButton";

class App{
	constructor(){
		this.mobileMenuButton = new MobileMenuButton();
		this.downloadImageButton = new DownloadImageButton();
	}

	// Initialize components
	boot(){
		this.mobileMenuButton.init();
		this.downloadImageButton.init();
	}
}

const app = new App();
app.boot();


// WEBPACK FOOTER //
// ./js/app.js